import axios from 'axios';

function trimSlash(value) {
  return (value || '').replace(/\/+$/, '');
}

function normalizeDevPhpBase(value) {
  const normalized = trimSlash(value);

  if (process.env.NODE_ENV !== 'development') {
    return normalized;
  }

  return normalized.replace(/^https:\/\/localhost:3004\//, 'https://localhost/');
}

const LEGACY_BASE = normalizeDevPhpBase(process.env.REACT_APP_API_URL || '');
const ROOT_BASE = normalizeDevPhpBase(
  process.env.REACT_APP_ROOT_URL || LEGACY_BASE.replace(/\/admin\/post_request$/, '')
);
const V2_BASE = trimSlash(`${ROOT_BASE}/api/v2`);

const v2Client = axios.create({
  baseURL: V2_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

const legacyClient = axios.create({
  baseURL: LEGACY_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

export function buildLegacyUrl(path) {
  return `${LEGACY_BASE}/${String(path || '').replace(/^\/+/, '')}`;
}

export async function getV2(path, config = {}) {
  const response = await v2Client.get(path, config);
  return response.data;
}

export async function postV2(path, payload = {}, config = {}) {
  const response = await v2Client.post(path, payload, config);
  return response.data;
}

export async function postLegacy(path, payload = {}, config = {}) {
  const response = await legacyClient.post(path, payload, config);
  return response.data;
}

export { LEGACY_BASE, ROOT_BASE, V2_BASE };
